import { render, staticRenderFns } from "./DraggableListsMobileLayers.vue?vue&type=template&id=22dbb8d1&scoped=true&"
import script from "./DraggableListsMobileLayers.vue?vue&type=script&lang=js&"
export * from "./DraggableListsMobileLayers.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsMobileLayers.vue?vue&type=style&index=0&id=22dbb8d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dbb8d1",
  null
  
)

export default component.exports